// extracted by mini-css-extract-plugin
module.exports = {"location_tiles":"ShipmentsTrackPageFeature_location_tiles__3KQ_8","itemContainer":"ShipmentsTrackPageFeature_itemContainer__17OAG","item":"ShipmentsTrackPageFeature_item__3usQp"};